export const SPELLING_STATE_ROOT_SELECTOR = state => state.spelling;

export const SPELLING_TYPING_UPDATE_STORE_SECONDS = 0.75;

export const SPELLING_MAX_WORD_LENGTH = 20;

export const SPELLING_MISTAKES_WIDTH = 43;

export const PRESENTING_BOARD_ID = -2;
export const STUDENT_PROFILE_BOARD_ID = -3;

export const STEPS = {
  WRITING: 1,
  HANDWRITING: 2,
  CODING: 3,
  SKETCHING: 4,
};

export const CLASSIFICATIONS_TYPES = {
  NON_SPECIFIC: 0,
  FORMULA: 1,
  SITUATION: 2,
  PHONETIC: 3,
};

export const ERROR_TYPES = {
  CORRECT: 1,
  INSERTION: 4, //     INSERTION     (old 1),
  OMISSION: 3, //      DELETION      (old 2),
  TRANSPOSITION: 5, // TRANSPOSITION (old 3),
  SUBSTITUTION: 2, //  REPLACEMENT   (old 4),
  PRESET: 6, //        NOT USED - server side
  // REPITITION: 7, //    PRESET        (old 5),
};

export const CLASSIFICATIONS = {
  [CLASSIFICATIONS_TYPES.NON_SPECIFIC]: { id: CLASSIFICATIONS_TYPES.NON_SPECIFIC, title: "Non-specific", shortTitle: "", color: "#ABE6C8" },
  [CLASSIFICATIONS_TYPES.FORMULA]: { id: CLASSIFICATIONS_TYPES.FORMULA, title: "Spelling Formula", shortTitle: "", color: "#FEDA9D" },
  [CLASSIFICATIONS_TYPES.SITUATION]: { id: CLASSIFICATIONS_TYPES.SITUATION, title: "Situational Spelling", shortTitle: "", color: "#72A3FF" },
  [CLASSIFICATIONS_TYPES.PHONETIC]: { id: CLASSIFICATIONS_TYPES.PHONETIC, title: "Misspelled Phoneme", shortTitle: "", color: "#EFBECB" },
};

export const CLASSIFICATIONS_OPTION = Object.values(CLASSIFICATIONS).map(concept => ({ value: concept.id, label: concept.title }));

export const ERRORS = {
  [ERROR_TYPES.INSERTION]: { id: ERROR_TYPES.INSERTION, title: "Inserted Letters", color: "#D95075", dialogTitle: "Inserted Letters", dialogSubTitle: "", classificationsOptions: [CLASSIFICATIONS_TYPES.NON_SPECIFIC] },
  [ERROR_TYPES.OMISSION]: { id: ERROR_TYPES.OMISSION, title: "Omitted Letters", color: "#FCBF53", dialogTitle: "Omitted Letters", dialogSubTitle: "", classificationsOptions: [CLASSIFICATIONS_TYPES.NON_SPECIFIC] },
  [ERROR_TYPES.SUBSTITUTION]: { id: ERROR_TYPES.SUBSTITUTION, title: "Concept Error", color: "#9290F4", dialogTitle: "Concept Error", dialogSubTitle: "", classificationsOptions: [CLASSIFICATIONS_TYPES.PHONETIC, CLASSIFICATIONS_TYPES.SITUATION, CLASSIFICATIONS_TYPES.FORMULA] },
  [ERROR_TYPES.TRANSPOSITION]: { id: ERROR_TYPES.TRANSPOSITION, title: "Incorrect Sequence", color: "#42B76B", dialogTitle: "Incorrect Sequence", dialogSubTitle: "Select first letter/s", classificationsOptions: [CLASSIFICATIONS_TYPES.NON_SPECIFIC] },

  //[ERROR_TYPES.REPITITION]: { id: ERROR_TYPES.REPITITION, title: "Repitition", color: "#0F1140", dialogTitle: "Repeating letters", dialogSubTitle: "Select first letter/s" },
};

export const MISTAKES_CONNECTING_TO_TYPES = {
  HIDDEN: -1,
  NONE: 0,
  LEFT: 1,
  RIGHT: 2,
  BOTH: 3,
};

export const DUMMY_WORDS = [
  { content: "get", base: "get" },
  { content: "ready", base: "readi" },
  { content: "read", base: "read" },
  { content: "minute", base: "minut" },
];

export const IMAGE_BACKGROUND_COLOR = "#C3E8D7";

export const SPELLING_TEXTS = {
  
  // Student
  STUDENT_HEAR_THE_WORD: "Hear the word",
  STUDENT_DONE: "All done!",
  STUDENT_INSTRUCTION_1: "Listen",
  STUDENT_INSTRUCTION_2_BASE: "Echo. Unblend the sounds.",
  STUDENT_INSTRUCTION_2_NONE_BASE: "Echo the derivative. Say the base word. Label and spell the suffix/prefix.",
  
  STUDENT_INSTRUCTION_3: "Spell the word silently",
  STUDENT_INSTRUCTION_4: "Name each letter and type silently",
  STUDENT_INSTRUCTION_5: "Code and read to check",
  

  // Therapist
  WAITING_FOR_SUBMIT: "Waiting for {NAME} to submit",
  WORD_NOT_SUBMIT: "{NAME} did not submit the word",
  SUBMIT_WITHOUT_WORD: "{NAME} clicked submit without typing the word",

  SPELL_CORRECTLY: "The word is spelled correctly",
  UNKNOWN_ERRORS: "We can't figure out what the errors are automatically.",
  YOU_CANADD_ERRORS: "You can add errors if necessary",

  ADD_ERROR_BUTTON_TOOLTOP: "See the instructions to learn about the different error types and classifications",

  ADD_ERROR_INSERTION: "Mark the inserted letter(s)",
  
  ADD_ERROR_OMISSION_FIRST: "Mark the omitted letter(s)",
  ADD_ERROR_OMISSION_LAST: "Mark its location in {NAME}'s response",
  ADD_ERROR_OMISSION_POSITION: "Mark the position",

  ADD_ERROR_REPITITION: "Select the redundant letter or sound",
  
  ADD_ERROR_SUBSTITUTION_SELECT_TARGET_LETTERS: "Select the substituted letter(s)",
  ADD_ERROR_SUBSTITUTION_SELECT_BEFORE: "Select the substituted letter(s)",

  ADD_ERROR_TRANSPOSITION_SELECT_LETTER_1: "Select the incorrectly sequenced letter(s)",
  ADD_ERROR_TRANSPOSITION_SELECT_LETTER_2: "Select the substituted letter(s)",
};
